











































import { Component, Vue, ModelSync } from 'vue-property-decorator';
import { FAQ } from '@/constants/faq';

@Component({})
export default class QHelpButton extends Vue {
  @ModelSync('value', 'change') showHelp!: boolean;

  faqs = FAQ;
}
